<section class="document-modal">
  <header class="document-modal__header">
    <div class="document-modal__heading">
      <span class="document-modal__heading-icon" aria-hidden="true">
        <span class="dashboard-icon dashboard-icon--20 dashboard-icon--download"></span>
      </span>

      <div class="document-modal__heading-copy">
        <h2>Laudos disponíveis</h2>
        <p *ngIf="!loading && !errorMessage">
          {{ schedules.length }} {{ schedules.length === 1 ? 'consulta' : 'consultas' }} com laudo
        </p>
      </div>
    </div>

    <button
      app-button
      type="button"
      color="neutral"
      appearance="tonal"
      size="sm"
      class="document-modal__close"
      aria-label="Fechar"
      (click)="close()"
    >
      <span app-button-content>&times;</span>
    </button>
  </header>

  <app-card-base class="document-modal__patient" appearance="default">
    <app-avatar
      class="document-modal__avatar"
      [text]="patientName"
      diameter="44px"
      fontSize="16px"
    ></app-avatar>

    <div class="document-modal__patient-copy">
      <strong>{{ patientName || '-' }}</strong>
      <span>CPF: {{ cpf || '-' }}</span>
    </div>
  </app-card-base>

  <p *ngIf="loading" class="document-modal__state">Carregando laudos...</p>
  <p *ngIf="errorMessage" class="document-modal__state document-modal__state--error">
    {{ errorMessage }}
  </p>
  <p *ngIf="!loading && !errorMessage && !schedules.length" class="document-modal__state">
    Nenhum laudo ativo disponível.
  </p>

  <div class="document-modal__list" *ngIf="!loading && !errorMessage && schedules.length">
    <app-card-base
      *ngFor="let schedule of schedules; trackBy: trackByScheduleId"
      class="document-modal__schedule-card"
      appearance="default"
    >
      <header class="document-modal__schedule-header">
        <span class="document-modal__schedule-header-text">
          {{ schedule.date | date: 'dd/MM/yyyy HH:mm' }} - {{ schedule.doctorName }}
        </span>
      </header>

      <button
        app-button
        type="button"
        color="neutral"
        appearance="basic"
        class="document-modal__item"
        *ngFor="let doc of schedule.documents"
        [attr.aria-label]="'Baixar ' + doc.documentType"
        (click)="openDocument(doc.url)"
      >
        <span app-button-content>
          <span class="document-modal__item-icon" aria-hidden="true">
            <span class="dashboard-icon dashboard-icon--18 dashboard-icon--download"></span>
          </span>

          <span class="document-modal__item-text">
            <strong class="document-modal__item-type">{{ doc.documentType }}</strong>
            <span class="document-modal__item-date">
              Emitido em {{ doc.createdAt | date: 'dd/MM/yyyy' }} às
              {{ doc.createdAt | date: 'HH:mm' }}
            </span>
          </span>

          <span class="document-modal__item-arrow" aria-hidden="true">
            <span class="dashboard-icon dashboard-icon--14 dashboard-icon--arrow-right"></span>
          </span>
        </span>
      </button>
    </app-card-base>
  </div>

  <footer class="document-modal__footer">
    <button
      app-button
      type="button"
      color="neutral"
      appearance="tonal"
      class="document-modal__footer-close"
      (click)="close()"
    >
      <span app-button-content>
        <span class="document-modal__footer-close-icon" aria-hidden="true">&times;</span>
        <span>Fechar</span>
      </span>
    </button>
  </footer>
</section>
